import React from 'react';

import './styles.scss';

export default class Loader extends React.Component {
    componentDidMount(){
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <section className="hero is-large loader-hero">
                <div className="hero-body">
                    <div className="container">
                        <i className="fas fa-circle-notch fa-spin"></i>
                    </div>
                </div>
            </section>
        )
    }
}